import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import AVisionOfExcellence from "./sections/AVisionOfExcellence";
import Eliteedgebespokecuration from "./sections/Eliteedgebespokecuration";
import Globaltrustsecurity from "./sections/Globaltrustsecurity";
import Vipconciergecare from "./sections/Vipconciergecare";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <AVisionOfExcellence />
      <Eliteedgebespokecuration />
      <Vipconciergecare />
      <Globaltrustsecurity />
      <Footer />
    </div>;
}